import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import fr from "./locales/fr.json";
import it from "./locales/it.json";

export const I18N_RESOURCES = {
  fr: { translation: fr },
  it: { translation: it },
};

void i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: I18N_RESOURCES,
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
